// window.location = '<?php echo home_url(); ?>'+'/confirmation?uuid=' + uuid + '&free='+free;
(function ($) {
	let url = window.location.href.split('?')[0];
	let mapPiece = $('.map-piece');

	if (mapPiece.length) {
		mapPiece.on('click', function (e) {
			e.preventDefault();

			let $continent = $(this).children('img').data('continent');
			if ($continent.length) {
				window.location = url + '?continents=' + $continent;
			}

			if (
				getUrlParameter('continents') &&
				$('.dealers-loop-item').length
			) {
				$('html, body').animate(
					{
						scrollTop: $('.dealers-loop').offset().top - 80,
					},
					1200
				);
			}
		});
	}
})(jQuery);
